import { useState, useEffect } from "react";

// PWA Breakpoints — mirror the thresholds used by the module-level
// `isMobile` / `isTablet` / `isDesktop` constants in `src/utils.js`
// (Feature 14077) so anything that swaps from the constant to this
// hook reads identical values.
//
// Why this hook exists (Bug #14972):
//   The exports in utils.js are evaluated once when the bundle first
//   loads. They never update on resize / display-scaling change, so
//   anything gated on them gets stuck — for example, SideNav hides
//   Compliance Center, Locations, Reports, BI Dashboard and Analytics
//   for the rest of the session if the user happened to load the app
//   while innerWidth was ≤ 1279.
const MOBILE_MAX = 767;
const TABLET_MAX = 1279;

const readViewport = () => {
    const w = (typeof window !== "undefined" ? window.innerWidth : Number.MAX_SAFE_INTEGER) || 0;
    return {
        isMobile: w <= MOBILE_MAX,
        isTablet: w > MOBILE_MAX && w <= TABLET_MAX,
        isDesktop: w > TABLET_MAX,
        width: w,
    };
};

const useViewport = () => {
    const [viewport, setViewport] = useState(readViewport);

    useEffect(() => {
        const handleResize = () => setViewport(readViewport());
        window.addEventListener("resize", handleResize);
        window.addEventListener("orientationchange", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("orientationchange", handleResize);
        };
    }, []);

    return viewport;
};

export default useViewport;
